import * as React from "react";
const SocialFacebookIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 40 40",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22 16v-2.382c0-1.074.238-1.618 1.906-1.618H26V8h-3.2c-4 0-5.6 2.669-5.6 5.6V16H14v4h3.2v12H22V20h3.525L26 16h-4Z",
  clipRule: "evenodd"
}));
export default SocialFacebookIcon;